import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { usersKeys } from '../queryKeys/usersKeys'
import { getUsers } from '../usersApi'

const useGetUsersQuery = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useQuery({
    queryKey: usersKeys.list(accountId),
    queryFn: () => getUsers(accountId),
    staleTime: 10 * 60 * 1000,
  })
}

export default useGetUsersQuery
